<template>
  <div class="card whitecollapse">
    <qc-collapse accordion v-model="activeName">
      <qc-collapse-item name="open" :inerror="anyInError">
        <div class="nowrap" slot="title" style="width: 100%">
          <div class="row xstarter">
            <span class="col-xs-1"><i class="fa fa-3x" :class="icon"/></span>
            <div class="col-xs-10" style="font-size: 1.2em; line-height: 100%; padding-top: 5px; padding-bottom: 5px; ">{{title}}</div>
            <div class="col-xs-1">
              <div class="row ">
                <span v-if="!public" class="text-muted col-xs-12" style="text-align: right;" :class="{'text-danger': numAction > 0}">{{numAction}}<i class="text-muted-no-override fa fa-exclamation" :class="{'text-danger': numAction > 0}"/></span>
                <span v-if="!public" class="text-muted col-xs-12" style="text-align: right;" :class="{'text-warning': numPending > 0}">{{numPending}}<i class="text-muted-no-override fa fa-clock-o" :class="{'text-warning': numPending > 0}"/></span>
                <span class="text-muted col-xs-12" style="text-align: right;" :class="{'text-success': numVerified > 0}">{{numVerified}}<i class="text-muted-no-override fa fa-check" :class="{'text-success': numVerified > 0}"/></span>
              <!-- <span class="pull-right">{{activeName == 'open' ? 'Close' : 'Open'}}</span> -->
              </div>
            </div>
          </div>
        </div>
        <div class="card-content row">
          <div class="col-lg-12">
            <qc-collapse>
              <qc-collapse-item v-for="verification, index in verifications" :name="title + index" :key="title + index" :overrideHeaderClick="showOrNav(verification)">
                <div class="nowrap" slot="title" style="width: 100%">
                  {{$service.educationName(verification, index)}}<span class="pull-right"><span class="label label-wd label-plain" :class="resultClass(verification.result)"><i class="fa" :class="resultIcon(verification.result)"></i>{{formatResult(verification.result)}}</span></span>
                </div>
                <result
                  :result="verification.result"
                  :notes="verification.notes"
                  :thirdPartyData="verification.fields['thirdPartyData']"
                  :verification="findBuiltVerification(verification)" />
                  <div class="col-md-10 col-md-offset-1">
                    <verification-timeline v-if="verification && verification.auditEvents && verification.auditEvents.length > 0" :events="verification.auditEvents" :onCard="false" />
                  </div>
              </qc-collapse-item>
            </qc-collapse>
            <br/>
            <button v-if="!public && allowAdd && !this.$store.state.sharingDisabled" @click="$router.push(newUrl)" type="button" class="btn btn-wd"><i class="fa fa-plus"></i> Add another {{title}} Verification</button>
          </div>
        </div>
      </qc-collapse-item>
    </qc-collapse>
  </div>
</template>

<script>
  import ModalOptions from 'src/components/ModalPlugin/ModalOptions'
  import QCCollapse from 'src/components/QCCollapse'
  import QCCollapseItem from 'src/components/QCCollapseItem'

  import Result from 'src/views/Verifications/components/Result'
  import VerificationTimeLine from 'src/views/Verifications/components/VerificationTimeLine'

  import _ from 'lodash'
  import { Loading } from 'element-ui';

  export default {
    name: "wallet-pocket",
    components: {
      'qc-collapse': QCCollapse,
      'qc-collapse-item': QCCollapseItem,
      Result,
      'verification-timeline': VerificationTimeLine
    },
    props: {
      title: String,
      icon: String,
      newUrl: String,
      public: {type: Boolean, default: false},
      verifications: {type: Array, default: []},
      builtVerifications: {type: Array, default: []},
      allowAdd: {type: Boolean, default: true},
      startOpen: {
        type: Boolean,
        default: false
        }
      },
    data() {
      return {
        activeName: this.startOpen ? 'open' : ''
      }
    },
    computed: {
      anyInError() {
        return this.verifications.some(v => v.result == 'REJECTED' || v.result == 'NOT_FOUND')
      },
      numVerified() {
        return this.verifications.filter(v => v.result == 'VERIFIED').length
      },
      numPending() {
        return this.verifications.filter(v => v.result == 'PENDING').length
      },
      numAction() {
        return this.verifications.filter(v => v.result == 'REJECTED' || v.result == 'NOT_FOUND').length
      }
    },
    watch: {
      startOpen(value) {
        this.activeName = value ? 'open' : ''
      }
    },
    methods: {
      num(result) {

      },
      findBuiltVerification(verification) {
        for(var i = 0; i < this.builtVerifications.length; i++) {
          if(this.builtVerifications[i].id == verification.id) {
            var useVerification = this.builtVerifications[i]
            if(this.public) {
              useVerification = _.cloneDeep(this.builtVerifications[i])
              useVerification.id = null
            }
            // console.log("using...")
            // console.log(JSON.stringify(useVerification))
            return useVerification
          }
        }
      },
      showOrNav(verification) {
        if(verification.result == 'REJECTED' || verification.result == 'NOT_FOUND') {
          return () => {
            this.$modal.show(ModalOptions,
              {
                title: "Action Required",
                message: "This verification requires your action, do you want to edit it now?",
                closeText: "Cancel",
                actionText1: "Edit",
                actionIcon1: "fa fa-pencil",
                action1: () => {
                  this.$router.push('/verification/history/' + verification.id)
                  this.$modal.close()
                }
              })
            }
        } else if (!this.public && this.activeName && verification.auditEvents == null) {
          return (defaultClickFunc) => {
            var loading = Loading.service({
              spinner: 'qc-spinner',
              text: 'Loading verification...'
            })
            this.$api.getVerificationAuditHistory(verification.id)
              .then(response => {
                verification.auditEvents = response.data.content
                defaultClickFunc()
                loading.close()
              })
              .catch(error => {
                loading.close()
              })
          }
        } else {
          return null
        }
      },
      formatResult(result) {
        switch (result) {
          case "PENDING": return "Pending"
          case "VERIFIED": return "Verified"
          case "NOT_VERIFIED": return "Not Verified"
          case "REJECTED": return "Action Required"
          case "NOT_FOUND": return "Action Required"
          case "CANCELLED": return "Cancelled"
          default: return null
        }
      },
      resultClass(result) {
        switch (result) {
          case "PENDING": return "text-warning"
          case "VERIFIED": return "text-success"
          case "NOT_VERIFIED": return "text-danger"
          case "REJECTED": return "text-danger"
          case "NOT_FOUND": return "text-danger"
          case "CANCELLED": return null
          default: return null
        }
      },
      resultIcon(result) {
        switch (result) {
          case "PENDING": return "fa-clock-o"
          case "VERIFIED": return "fa-check"
          case "NOT_VERIFIED": return "fa-times"
          case "REJECTED": return "fa-exclamation"
          case "NOT_FOUND": return "fa-exclamation"
          case "CANCELLED": return null
          default: return null
        }
      }
    }
  }
</script>
